export class GeocodingRequest {
    address1: string;
    city: string;
    zip: string;
    state: string;
    country: string;

    constructor(address1: string,
        city: string,
        zip: string,
        state: string,
        country = 'USA') {
        this.address1 = address1;
        this.city = city;
        this.zip = zip;
        this.state = state;
        this.country = country;
    }
} 